module.exports = __webpack_public_path__ + "img/nikolai-lockertsen-river-view.9e25ffc.jpg";